import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { LocalizationProvider } from '@material-ui/pickers';
import DateFnsUtils from '@material-ui/pickers/adapter/date-fns';
import React, { FC, PropsWithChildren } from 'react';
import { I18nextProvider } from 'react-i18next';
import { ThemeProvider } from 'styled-components';
import i18n from '../localization';
import { theme } from '../theme';

const CoreProvider: FC<PropsWithChildren<unknown>> = ({ children }) => (
  <MuiThemeProvider theme={theme}>
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={DateFnsUtils}>
        <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
      </LocalizationProvider>
    </ThemeProvider>
  </MuiThemeProvider>
);

export default CoreProvider;
